import { confirmation, notify } from '@/components';
import { useRemoveAnnouncementMutation } from '@/redux/announcements';

interface ActionProps {
  onSuccess?: () => any;
}

const useDelete = (props?: ActionProps) => {
  const { onSuccess } = props ?? {};
  const [remove] = useRemoveAnnouncementMutation();

  return async (id: string) => {
    confirmation.delete({ key: 'announcements.entity' }, () => {
      remove({ id })
        .unwrap()
        .then(() => {
          notify.success.t('announcements.details.deleted');
        })
        .then(() => onSuccess && onSuccess());
    });
  };
};

export function useDeleteAnnouncementAction(props?: ActionProps) {
  const deleteAction = useDelete(props);

  return {
    deleteAction,
  };
}

